module.exports = __webpack_public_path__ + "img/guide_10.7af80308.png";